// extracted by mini-css-extract-plugin
module.exports = {"menu":"QGZJ0BN04EghbR0z-uqteA==","menuItem":"pZQeOPDtCz+B6wPK419TOw=="};